<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'

import { stringOrUndefined } from '@/helpers/StringHelpers'

import { useGlobalError } from '@/stores/useGlobalErrorStore'

import DonationCompletePage from '@/pages/DonationCompletePage.vue'

import LoadingSpinner from '@/components/LoadingSpinner.vue'
import PageLayout from '@/components/templates/PageLayout.vue'

const route = useRoute()
const router = useRouter()
const globalError = useGlobalError()

const id = stringOrUndefined(route.params.id)
const receiptEmail = stringOrUndefined(route.query.email)
const orderNumber = stringOrUndefined(route.query.order)
const donationAmount = Number(stringOrUndefined(route.query.amount) ?? 0)

const notFound = !id || !receiptEmail || !orderNumber

if (!id) globalError.set('Not found', { dismissable: false })
else if (notFound) router.push({ name: 'donation', params: { id } })
else {
  // Strip receipt details from the URL so a refresh or shared link doesn't keep PII in the address bar.
  const { email, order, amount, ...rest } = route.query
  const queryString = new URLSearchParams(Object.entries(rest) as [string, string][]).toString()
  history.replaceState(null, '', queryString ? `${route.path}?${queryString}` : route.path)
}
</script>

<template>
  <PageLayout>
    <Suspense v-if="!notFound">
      <template #fallback><LoadingSpinner /> </template>
      <DonationCompletePage
        :id="id!"
        :donationAmount="donationAmount"
        :orderNumber="orderNumber!"
        :receiptEmail="receiptEmail!"
      />
    </Suspense>
  </PageLayout>
</template>
